<template>
  <div>
    <DataTable
      :value="citiesTowns"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedCitiesTowns"
      :filters="{ global: filters }"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Cities/Towns"
    >
      <template #empty> No Cities/Towns found. </template>
      <template #loading> Loading Cities/Towsn data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="cityTownName"
        header="City/Town Name"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.cityTownName }}
          </div>
        </template>
      </Column>
      <Column
        field="postCodeArea"
        header="Postal Code Area"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.postCodeArea }}
          </div>
        </template>
      </Column>
      <Column
        field="country"
        header="Country"
        headerStyle="width: 6em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.country }}
          </div>
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-info" 
              class="p-button-success p-mb-2"
              @click="editCityTown(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import PermissionMixin from '../../PermissionMixin.vue'
export default {
  mixins: [PermissionMixin],
  props: [
    'citiesTowns',
    'loading',
    'filters'
  ],
  data: () => ({
    selectedCitiesTowns: null
  }),
  methods: {
    getButtons(data) { 
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteCityTown(data)
            }
          }
        )
      }
      return buttons
    },
    deleteCityTown(cityTown) {
      this.$emit('delete-city-town', cityTown)
    },
    editCityTown(cityTown) {
      this.$emit('edit-city-town', cityTown)
    }
  }
}
</script>

<style>

</style>